import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, ShoppingCart } from 'lucide-react';
import { useCart } from '../context/CartContext';
import NenaLogo from '../images/NenaLogo.svg';

const Navigation = ({ onCartOpen }) => {
  const { state } = useCart();
  const cartItemCount = state.items.reduce((sum, item) => sum + item.quantity, 0);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);
  const closeMobileMenu = () => setIsMobileMenuOpen(false);

  const linkClasses = "font-serif tracking-wide text-sm uppercase text-[#3D2817] hover:text-[#6B7C3F] transition-colors";

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-[#FAF6EE] border-b border-[#E5DCC9]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Desktop */}
        <div className="hidden md:grid grid-cols-3 items-center h-20">
          <div className="flex items-center gap-8">
            <Link to="/" className={linkClasses}>Home</Link>
            <Link to="/cakes" className={linkClasses}>Shop</Link>
            <Link to="/contact" className={linkClasses}>Contact</Link>
          </div>

          <Link to="/" className="justify-self-center">
            <img src={NenaLogo} alt="Nena Miami" className="h-14 w-auto" />
          </Link>

          <div className="flex items-center justify-end gap-6">
            <a
              href="https://instagram.com/nenamiami"
              target="_blank"
              rel="noopener noreferrer"
              className={linkClasses}
            >
              Instagram
            </a>
            <button
              onClick={onCartOpen}
              className="relative text-[#3D2817] hover:text-[#6B7C3F] transition-colors"
              aria-label="Open cart"
            >
              <ShoppingCart className="w-5 h-5" />
              {cartItemCount > 0 && (
                <span className="absolute -top-2 -right-2 bg-[#6B7C3F] text-[#FAF6EE] text-xs rounded-full w-5 h-5 flex items-center justify-center font-medium">
                  {cartItemCount}
                </span>
              )}
            </button>
          </div>
        </div>

        {/* Mobile */}
        <div className="md:hidden">
          <div className="flex justify-between items-center h-16">
            <Link to="/" className="flex items-center">
              <img src={NenaLogo} alt="Nena Miami" className="h-10 w-auto" />
            </Link>

            <div className="flex items-center gap-4">
              <button
                onClick={onCartOpen}
                className="relative text-[#3D2817] hover:text-[#6B7C3F] transition-colors"
                aria-label="Open cart"
              >
                <ShoppingCart className="w-5 h-5" />
                {cartItemCount > 0 && (
                  <span className="absolute -top-2 -right-2 bg-[#6B7C3F] text-[#FAF6EE] text-xs rounded-full w-5 h-5 flex items-center justify-center font-medium">
                    {cartItemCount}
                  </span>
                )}
              </button>
              <button
                onClick={toggleMobileMenu}
                className="text-[#3D2817] hover:text-[#6B7C3F] transition-colors p-1"
                aria-label="Toggle menu"
              >
                {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
              </button>
            </div>
          </div>

          <div
            className={`fixed inset-0 top-16 bg-[#FAF6EE] z-50 transition-transform duration-300 ease-in-out ${
              isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'
            }`}
          >
            <div className="flex flex-col items-center justify-center h-full gap-8">
              <Link to="/" onClick={closeMobileMenu} className="font-serif text-2xl tracking-wide text-[#3D2817] hover:text-[#6B7C3F] transition-colors">
                Home
              </Link>
              <Link to="/cakes" onClick={closeMobileMenu} className="font-serif text-2xl tracking-wide text-[#3D2817] hover:text-[#6B7C3F] transition-colors">
                Shop
              </Link>
              <a
                href="https://instagram.com/nenamiami"
                target="_blank"
                rel="noopener noreferrer"
                className="font-serif text-2xl tracking-wide text-[#3D2817] hover:text-[#6B7C3F] transition-colors"
              >
                Instagram
              </a>
              <Link to="/contact" onClick={closeMobileMenu} className="font-serif text-2xl tracking-wide text-[#3D2817] hover:text-[#6B7C3F] transition-colors">
                Contact
              </Link>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
